if ( window.wp && window.wp.ajax ) {
    const { registerBlockType } = window.wp.blocks;

    const { 
        RichText,
        InspectorControls
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        TextControl,
        CheckboxControl
    } = window.wp.components;

    const {
        useState
    } = window.wp.element;

    const { 
        useBlockProps 
    } = window.wp.blockEditor;

    registerBlockType('custom-gutenberg/tab-button', {
        // built-in attributes
        title: 'Tab Button',
        description: 'Tab',
        icon: 'slides',
        category: 'tabs',
        example: {},
        parent: ['custom-gutenberg/nav-tabs'],

        // custom attributes
        attributes: {
            id: {
                type: 'string',
                default: '',
            },
            title: {
                type: 'string',
                default: '',
            },
            active: {
                type: 'boolean',
                default: false,
            },
        },

        edit ({ attributes, setAttributes }) {

            const {
                id,
                title,
                active
            } = attributes;

            // custom functions
            const [ isCheched, setChecked ] = useState( false );
            setAttributes({active: isCheched});

            function onTitleChange (title) {
                setAttributes({title: title});
            };

            function onIdChange (id) {
                setAttributes({id: id});
            };

            const blockProps = useBlockProps( {
                className: 'nav-link' + (active ? ' active' : ''),
            } );

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Tab settings' }>
                        <p><strong>ID must be unique</strong></p>
                        <TextControl value={ id } onChange={ onIdChange }></TextControl>
                        <CheckboxControl
                            label="Is default active tab"
                            help="Only ONE tab can be default active!"
                            checked={ isCheched }
                            onChange={ setChecked  }
                        />
                    </PanelBody>
                </InspectorControls>,
                <button { ...blockProps } id={ id + "-tab"} data-bs-toggle="tab" data-bs-target={ "#" + id } type="button" role="tab">
                    <RichText 
                        key="editable" 
                        tagName="span" 
                        placeholder="Skijanje" 
                        value={ title }
                        onChange={ onTitleChange } />
                </button>
            ]);
        },

        save ({ attributes }) {

            const {
                id,
                title,
                active
            } = attributes;

            return ( 
                <button class={ "nav-link" + (active ? ' active' : '' ) } id={ id + "-tab" } data-bs-toggle="tab" data-bs-target={ "#" + id } type="button" role="tab">
                    { title }
                </button>
            );
        },
    });
}